import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n } from 'common'
import {
  ReceiptDivider,
  ReceiptLabel,
  ReceiptTextRow,
  ReceiptValue,
} from '../printStyles'

interface Props {
  vehicleName: string
  personalNote: string
  customerName: string | undefined
  cartId: string | number | undefined
  orderDate: string
}

const Header = (props: Props): ReactElement => {
  const { vehicleName, personalNote, customerName, cartId, orderDate } = props

  return (
    <Wrapper>
      <VehicleNameBar>{vehicleName}</VehicleNameBar>
      <ReceiptTextRow>
        <ReceiptLabel>
          <I18n name="orderedON" />
        </ReceiptLabel>
        <ReceiptValue>{orderDate}</ReceiptValue>
        <ReceiptDivider>|</ReceiptDivider>
        <ReceiptLabel>
          <I18n name="cartID" />
        </ReceiptLabel>
        <ReceiptValue>{cartId}</ReceiptValue>
        <ReceiptDivider>|</ReceiptDivider>
        <ReceiptLabel>
          <I18n name="customerName" />
        </ReceiptLabel>
        <ReceiptValue>{customerName}</ReceiptValue>
        {personalNote && (
          <>
            <ReceiptDivider>|</ReceiptDivider>
            <ReceiptLabel>
              <I18n name="personalNote" />
            </ReceiptLabel>
            <ReceiptValue>{personalNote}</ReceiptValue>
          </>
        )}
      </ReceiptTextRow>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

const VehicleNameBar = styled.div`
  font-family: Oswald, serif;
  font-weight: 700;
  font-size: 11pt;
  line-height: 14pt;
  padding: 4px 6px;
  background-color: ${(p) => p.theme.colors.rowFeaturedBackground};
  text-transform: uppercase;
`

export default Header
